import React from "react";
import { Typography } from "@mui/material";
const NormalCell = ({ row, type }) => {
  return (
    <Typography textTransform={"capitalize"} fontSize="15px">
      {type === "number" ? row.text || "0" : row.text || "--"}
    </Typography>
  );
};

export default NormalCell;
